var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrder(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#5E5E66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.88233C2 2.84275 2.84275 2 3.88233 2H16.1177C17.1573 2 18 2.84275 18 3.88233V16.1177C18 17.1573 17.1573 18 16.1177 18H3.88233C2.84275 18 2 17.1573 2 16.1177V3.88233ZM3.88233 3.49533C3.66859 3.49533 3.49533 3.66859 3.49533 3.88233V16.1177C3.49533 16.3314 3.66859 16.5047 3.88233 16.5047H16.1177C16.3314 16.5047 16.5047 16.3314 16.5047 16.1177V3.88233C16.5047 3.66859 16.3314 3.49533 16.1177 3.49533H3.88233Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48876 8.34587C5.48876 7.93295 5.8235 7.59821 6.23642 7.59821H11.7741C12.1871 7.59821 12.5218 7.93295 12.5218 8.34587C12.5218 8.7588 12.1871 9.09354 11.7741 9.09354H6.23642C5.8235 9.09354 5.48876 8.7588 5.48876 8.34587Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48821 13.0072C5.48821 12.5942 5.82295 12.2595 6.23587 12.2595H13.7736C14.1865 12.2595 14.5213 12.5942 14.5213 13.0072C14.5213 13.4201 14.1865 13.7548 13.7736 13.7548H6.23587C5.82295 13.7548 5.48821 13.4201 5.48821 13.0072Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.03730aaa.svg";
export { ForwardRef as ReactComponent };